import React from "react";
import eclinimg from "../../../assets/images/eclinpro.png";
import eclinfailedimg from "../../../assets/images/eClinProFailed.svg";

const EclinProSyncBadge = ({
  isSynced = true,
  IsNav = false,
  label = "eClinPro Synced",
  isSyncedStatus,
  eclinProSyncResult,
}) => {
  if (!isSynced) return null;
  const parsedErrorResult = JSON.parse(eclinProSyncResult);
 
  return (
    <div className={`relative inline-flex group ${IsNav ? "ml-0" : "ml-4"}`}>
      {/* Icon */}
      <img
        src={parsedErrorResult?.success === false ? eclinfailedimg : eclinimg}
        alt="eClinPro"
        className="h-6 w-6 cursor-pointer"
      />

      {/* Tooltip */}
      <div
        className="absolute top-full left-1/2 -translate-x-1/2 mt-2 
 opacity-0 group-hover:opacity-100 transition-opacity duration-200 
 bg-white text-[#1A1A1B] border border-[#E4E4E4] 
 text-xs px-2 py-1 rounded z-10 whitespace-nowrap 
 w-[42px] h-[32px] flex items-center justify-center tooltip"
      >
        {parsedErrorResult?.success === false ? parsedErrorResult.error : label}
      </div>
    </div>
  );
};

export default EclinProSyncBadge;
